// extracted by mini-css-extract-plugin
module.exports = {"root":"Banner1_root__2uD8R"};